/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  getEvolutionConnection(inboxId, { refreshCode = false } = {}) {
    return axios.get(`${this.url}/${inboxId}/evolution_connection`, {
      params: refreshCode ? { refresh_code: true } : {},
    });
  }

  createGowaDevice(name) {
    return axios.post(`${this.baseUrl()}/gowa/devices`, { name });
  }

  getGowaConnection(inboxId, { refreshCode = false } = {}) {
    return axios.get(`${this.url}/${inboxId}/gowa_connection`, {
      params: refreshCode ? { refresh_code: true } : {},
    });
  }

  disconnectGowaInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/gowa_disconnect`);
  }

  importEvolutionContacts(inboxId, { label } = {}) {
    return axios.post(`${this.url}/${inboxId}/evolution_import_contacts`, {
      label,
    });
  }

  getEvolutionImportContactsStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_import_contacts_status`);
  }

  getEvolutionHistorySummary(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_history_summary`);
  }

  importEvolutionHistory(inboxId, { since, until } = {}) {
    return axios.post(`${this.url}/${inboxId}/evolution_import_history`, {
      since,
      until,
    });
  }

  getEvolutionImportHistoryStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_import_history_status`);
  }

  disconnectEvolutionInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution_disconnect`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }
}

export default new Inboxes();
